import { send6SenseDataToAda, updateChatbotLanguage } from "./plugin-functions";

export const onRouteUpdate = async ({ location, prevLocation }) => {
    await updateChatbotLanguage(location);
    await send6SenseDataToAda();
};
